import { LovePage } from 'web/components/love-page'

export default function About() {
  return (
    <LovePage trackPageView={'user profiles'}>
      Manifold love development is on hiatus.
      <br />
      <br />
      You answer questions and get a compatibility score.
      <br />
      Then you can like someone once a day to unlock the ability to message
      them.
    </LovePage>
  )
}
